import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translations
import { translations } from './translations';

// Convert translations object to i18next format
const resources = {};
Object.keys(translations).forEach(lang => {
  resources[lang] = {
    translation: translations[lang]
  };
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Key to store language in localStorage
      lookupLocalStorage: 'sqawk_language',
      // Cache user language
      caches: ['localStorage'],
    },
    
    // Supported languages (11 total for sQawk)
    supportedLngs: ['en', 'es', 'pt', 'fr', 'de', 'it', 'zh', 'ja', 'ko', 'ar', 'hi'],
    
    // Don't load translation files, use embedded resources
    react: {
      useSuspense: false, // Avoid suspense for SSR compatibility
    }
  });

// Helper function to change language
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  localStorage.setItem('sqawk_language', lng);
};

// Get current language
export const getCurrentLanguage = () => {
  return i18n.language || localStorage.getItem('sqawk_language') || 'en';
};

export default i18n;
